// Painel de vistorias (aba dash). Port de buildDashViz/buildDash/reprovarRapido/cobrarAloj
// (index.html:2543–2822, 4805). Os números vêm prontos de GET /api/painel.

import { classificar } from '../motor/index.js';
import type { PainelDTO, VistoriaDTO } from '../compartilhado/api.js';
import { api, ErroApi } from './api.js';
import { G, can, carregando, makeCard, renderAdmin, semAprovar, compAtual } from './gestao-shell.js';
import { seePDF } from './gestao-hist.js';
import { S, hoje } from './vistoriador.js';
import { COR_FORM, compTxt, esc, rotuloTxt, toast } from './util.js';

function corMedia(m: number | null) { return m === null ? '#94a3b8' : COR_FORM[classificar(m).faixa]; }
function txtComp(c: { ano: number; mes: number }) { return rotuloTxt(compTxt(c)); }

export function abrirTodasObras(v: boolean) {
  G.cadastro.forEach(function (ob: any) { G.obrasAbertas[ob.id] = v; });
  renderAdmin('dash');
}
export function toggleObra(id: string) {
  G.obrasAbertas[id] = !G.obrasAbertas[id];
  const corpo = document.getElementById('obra-b-' + id);
  const seta = document.getElementById('obra-s-' + id);
  if (corpo) corpo.style.display = G.obrasAbertas[id] ? 'block' : 'none';
  if (seta) seta.textContent = G.obrasAbertas[id] ? '▼' : '▶';
  const info = document.getElementById('dash-openinfo');
  if (info) {
    const obras = G.cadastro;
    const ab = obras.filter(function (o: any) { return G.obrasAbertas[o.id]; }).length;
    info.textContent = obras.length + ' obra' + (obras.length === 1 ? '' : 's') + ' · ' + ab + ' aberta(s)';
  }
}

function buildDashViz(el: HTMLElement, p: PainelDTO) {
  const r = p.resumo, compActive = txtComp(r.competencia);
  const avg = r.media, diff = r.diferenca;
  const wrap = document.createElement('div'); wrap.className = 'dz';
  const k = document.createElement('div'); k.className = 'dz-kpis';
  k.innerHTML =
    '<div class="dz-hero"><span class="dz-l">Média geral das obras</span><div><span class="dz-big">' + (avg !== null ? Math.round(avg) + '%' : '—') + '</span>'
    + (diff !== null ? '<span class="dz-diff">' + (diff >= 0 ? '+' : '') + Math.round(diff) + ' pts</span>' : '') + '</div></div>'
    + '<div class="dz-k"><span class="dz-l2">Obras ativas</span><span class="dz-n">' + G.cadastro.length + '</span><span class="dz-s">' + r.totalAlojamentos + ' alojamento(s) · 4 vistorias no mês</span></div>'
    + '<div class="dz-k"><span class="dz-l2">Vistorias feitas</span><span class="dz-n">' + r.recebidas + '<small> / ' + r.meta + '</small></span><div class="dz-track"><i style="width:' + r.percentualKpi + '%"></i></div></div>'
    + '<div class="dz-k"><span class="dz-l2">Pendentes de cobrança</span><span class="dz-n" style="color:' + (r.pendentes > 0 ? '#B3261E' : '#14633F') + '">' + r.pendentes + '</span><span class="dz-s">alojamentos com menos de 4</span></div>';
  wrap.appendChild(k);

  const two = document.createElement('div'); two.className = 'dz-two';
  const rk = document.createElement('div'); rk.className = 'card dz-card';
  let rh = '<h2>Ranking das obras</h2><p>Da melhor para a pior média de ' + esc(compActive) + '</p><div class="dz-rank">';
  r.ranking.forEach(function (x, i) {
    rh += '<div class="dz-row"><b class="dz-pos' + (i === 0 && x.media !== null ? ' first' : '') + '">' + (i + 1) + '</b><div><div class="dz-nm">' + esc(x.nome) + '</div>'
      + '<div class="dz-bar' + (x.media !== null && x.media < 80 ? ' low' : '') + '" style="width:' + (x.media !== null ? Math.max(3, Math.round(x.media)) : 0) + '%;animation-delay:' + (i * 0.07) + 's"></div></div>'
      + '<b class="dz-pc">' + (x.media !== null ? Math.round(x.media) + '%' : '—') + '</b></div>';
  });
  if (!r.ranking.length) rh += '<div class="dz-s">Nenhuma obra cadastrada.</div>';
  rk.innerHTML = rh + '</div>';
  const ev = document.createElement('div'); ev.className = 'card dz-card';
  let cols = '', labs = '';
  r.evolucao.forEach(function (e, i) {
    const v = e.media;
    cols += '<div class="dz-colw"><b>' + (v !== null ? Math.round(v) + '%' : '—') + '</b><div class="dz-col' + (e.atual ? ' hi' : '') + '" style="height:' + (v !== null ? Math.max(6, Math.round(v * 1.9)) : 6) + 'px;animation-delay:' + (i * 0.07) + 's"></div></div>';
    labs += '<span>' + esc(txtComp(e.competencia).split('/')[0]!.slice(0, 3).toLowerCase()) + '</span>';
  });
  const n = Math.max(1, r.evolucao.length);
  ev.innerHTML = '<h2>Evolução no ano</h2><p>Média geral por mês</p><div class="dz-cols" style="grid-template-columns:repeat(' + n + ',1fr)">' + cols + '</div><div class="dz-labs" style="grid-template-columns:repeat(' + n + ',1fr)">' + labs + '</div>';
  two.appendChild(rk); two.appendChild(ev); wrap.appendChild(two);
  el.appendChild(wrap);
}

export async function buildDash(el: HTMLElement) {
  carregando(el);
  const comp = compAtual();
  const [p] = await Promise.all([
    api<PainelDTO>('GET', '/api/painel?comp=' + comp),
    G.cadastro.length ? Promise.resolve(G.cadastro) : api('GET', '/api/cadastro').then(function (c) { G.cadastro = c; return c; }),
  ]);
  if (S.tab !== 'dash') return;
  el.innerHTML = '';
  const r = p.resumo;
  const compActive = rotuloTxt(comp);
  try { buildDashViz(el, p); } catch (e) { console.error(e); }

  const card = makeCard('📊 ' + esc(compActive) + ' — Progresso por alojamento', function (b) {
    const selBar = document.createElement('div');
    selBar.style.cssText = 'display:flex;align-items:center;gap:10px;margin-bottom:14px;flex-wrap:wrap';
    const lbC = document.createElement('span');
    lbC.style.cssText = 'font-size:12px;font-weight:700;color:#64748b';
    lbC.textContent = '📅 Competência:';
    const selC = document.createElement('select');
    selC.style.cssText = 'padding:8px 14px;border:1.5px solid #e2e8f0;border-radius:10px;font-size:13px;font-weight:700;color:#1F3864;outline:none;cursor:pointer;background:#fff';
    p.competencias.forEach(function (cp) {
      const o = document.createElement('option'); o.value = cp; o.textContent = rotuloTxt(cp);
      if (cp === comp) o.selected = true; selC.appendChild(o);
    });
    selC.onchange = function () { G.compView = selC.value; renderAdmin('dash'); };
    selBar.appendChild(lbC); selBar.appendChild(selC);
    if (comp !== compTxt(hoje())) {
      const bHoje = document.createElement('button');
      bHoje.style.cssText = 'background:#fff;border:1.5px solid #e2e8f0;border-radius:10px;padding:7px 12px;font-size:12px;font-weight:700;color:#334155;cursor:pointer;font-family:inherit';
      bHoje.textContent = 'Mês atual';
      bHoje.onclick = function () { G.compView = compTxt(hoje()); renderAdmin('dash'); };
      selBar.appendChild(bHoje);
    }
    b.appendChild(selBar);

    const aviso = document.createElement('div');
    aviso.style.cssText = 'border-radius:10px;padding:10px 14px;font-size:13px;margin-bottom:14px;font-weight:600;border:1.5px solid';
    if (r.pendentes > 0) { aviso.style.background = '#fef2f2'; aviso.style.borderColor = '#fca5a5'; aviso.style.color = '#b91c1c';
      aviso.innerHTML = '⚠️ ' + r.pendentes + ' alojamento(s) sem as 4 vistorias em ' + esc(compActive); }
    else { aviso.style.background = '#f0fdf4'; aviso.style.borderColor = '#86efac'; aviso.style.color = '#16a34a';
      aviso.innerHTML = '✅ Todos os alojamentos têm 4 vistorias em ' + esc(compActive) + '!'; }
    b.appendChild(aviso);

    const prog = document.createElement('div');
    prog.style.cssText = 'background:#f8fafc;border:1px solid #e2e8f0;border-radius:12px;padding:14px 16px;margin-bottom:14px';
    prog.innerHTML = '<div style="display:flex;align-items:baseline;justify-content:space-between;gap:10px;flex-wrap:wrap">'
      + '<div style="font-weight:700;font-size:13px;color:#1e293b">Vistorias recebidas em ' + esc(compActive) + '</div>'
      + '<div style="font-size:13px;color:#64748b"><strong style="font-size:20px;color:#1F3864">' + r.recebidas + '</strong> de ' + r.meta + '</div>'
      + '</div>'
      + '<div style="height:8px;background:#e2e8f0;border-radius:99px;margin:10px 0 6px;overflow:hidden">'
      + '<div style="height:100%;width:' + Math.min(100, r.percentual) + '%;background:linear-gradient(90deg,#1F3864,#2E5C8A);border-radius:99px"></div></div>'
      + '<div style="font-size:11px;color:#64748b">' + r.totalAlojamentos + ' alojamentos × 4 vistorias · ' + r.percentual + '% do mês</div>';
    b.appendChild(prog);

    if (!p.obras.length) {
      const vazio = document.createElement('div');
      vazio.style.cssText = 'text-align:center;padding:30px;color:#94a3b8;font-size:13px';
      vazio.textContent = 'Nenhum alojamento cadastrado.';
      b.appendChild(vazio); return;
    }

    const obras = G.cadastro;
    const ctrl = document.createElement('div');
    ctrl.style.cssText = 'display:flex;align-items:center;justify-content:space-between;gap:10px;margin-bottom:10px;flex-wrap:wrap';
    const abertas = obras.filter(function (o: any) { return G.obrasAbertas[o.id]; }).length;
    const info = document.createElement('div'); info.id = 'dash-openinfo';
    info.style.cssText = 'font-size:12px;color:#64748b;font-weight:600';
    info.textContent = obras.length + ' obra' + (obras.length === 1 ? '' : 's') + ' · ' + abertas + ' aberta(s)';
    const bts = document.createElement('div'); bts.style.cssText = 'display:flex;gap:8px';
    const bA = document.createElement('button');
    bA.style.cssText = 'background:#fff;border:1.5px solid #e2e8f0;border-radius:10px;padding:6px 14px;font-size:12px;font-weight:700;color:#334155;cursor:pointer;font-family:inherit';
    bA.textContent = 'Abrir todas'; bA.onclick = function () { abrirTodasObras(true); };
    const bR = document.createElement('button');
    bR.style.cssText = bA.style.cssText;
    bR.textContent = 'Recolher todas'; bR.onclick = function () { abrirTodasObras(false); };
    bts.appendChild(bA); bts.appendChild(bR);
    ctrl.appendChild(info); ctrl.appendChild(bts);
    b.appendChild(ctrl);

    const obrasGrid = document.createElement('div'); obrasGrid.style.cssText = 'display:grid;grid-template-columns:1fr;align-items:start';
    b.appendChild(obrasGrid);
    p.obras.forEach(function (ob) {
      const als = ob.alojamentos;
      const aberta = !!G.obrasAbertas[ob.obraId];
      const wrap = document.createElement('div');
      wrap.style.cssText = 'border:1px solid #e2e8f0;border-radius:12px;margin-bottom:8px;overflow:hidden;background:#fff';
      const head = document.createElement('button');
      head.style.cssText = 'display:flex;align-items:center;gap:10px;width:100%;background:#fff;border:none;padding:14px 16px;cursor:pointer;font-family:inherit;text-align:left';
      head.onmouseover = function () { head.style.background = '#f8fafc'; };
      head.onmouseout = function () { head.style.background = '#fff'; };
      const seta = document.createElement('span'); seta.id = 'obra-s-' + ob.obraId;
      seta.style.cssText = 'color:#64748b;font-size:11px;flex-shrink:0';
      seta.textContent = aberta ? '▼' : '▶';
      const nome = document.createElement('span');
      nome.style.cssText = 'flex:1;font-weight:800;font-size:13px;color:#1F3864;text-transform:uppercase;letter-spacing:.3px;min-width:0';
      nome.textContent = ob.nome;
      const bg1 = document.createElement('span');
      bg1.style.cssText = 'border-radius:99px;padding:3px 10px;font-size:11px;font-weight:700;white-space:nowrap;' +
        (ob.recebidas === 0 ? 'background:#fee2e2;color:#b91c1c' : 'background:#dbeafe;color:#1e40af');
      bg1.textContent = ob.recebidas + '/' + ob.meta + ' vistorias';
      const bg2 = document.createElement('span');
      bg2.style.cssText = 'border-radius:99px;padding:3px 10px;font-size:11px;font-weight:700;white-space:nowrap;' +
        (ob.completos === als.length ? 'background:#dcfce7;color:#166534' : 'background:#f1f5f9;color:#64748b');
      bg2.textContent = ob.completos + '/' + als.length + ' completos';
      head.appendChild(seta); head.appendChild(nome); head.appendChild(bg1); head.appendChild(bg2);
      head.onclick = function () { toggleObra(ob.obraId); };
      wrap.appendChild(head);

      const corpo = document.createElement('div');
      corpo.id = 'obra-b-' + ob.obraId;
      corpo.style.cssText = 'display:' + (aberta ? 'block' : 'none') + ';border-top:1px solid #eef2f7;background:#fbfdff;padding:10px 12px';

      als.forEach(function (al) {
        const count = al.contagem, media = al.media;
        const box = document.createElement('div');
        box.style.cssText = 'background:#fff;border:1px solid #e8eef6;border-radius:10px;padding:10px 12px;margin-bottom:8px';
        const topo = document.createElement('div');
        topo.style.cssText = 'display:flex;align-items:flex-start;justify-content:space-between;gap:10px;flex-wrap:wrap';
        const esq = document.createElement('div'); esq.style.minWidth = '0';
        esq.innerHTML = '<div style="font-weight:700;font-size:13px;color:#1e293b">📍 ' + esc(al.nome) + '</div>'
          + '<div style="font-size:11px;color:#64748b">👤 ' + esc(al.responsavel || '—') + '</div>';
        const dir = document.createElement('div'); dir.style.cssText = 'text-align:right;flex-shrink:0';
        const cor = corMedia(media);
        dir.innerHTML = (media !== null ? '<div style="font-weight:800;font-size:16px;color:' + cor + '">' + media.toFixed(1) + '%</div>' : '')
          + '<div style="font-size:11px;color:' + (count >= 4 ? '#16a34a' : count > 0 ? '#d97706' : '#dc2626') + ';font-weight:700">' + count + '/4 vistorias</div>';
        topo.appendChild(esq); topo.appendChild(dir); box.appendChild(topo);

        const pontos = document.createElement('div');
        pontos.style.cssText = 'display:flex;align-items:center;gap:4px;margin-top:8px;flex-wrap:wrap';
        ['1ª', '2ª', '3ª', '4ª'].forEach(function (w, i) {
          const d = document.createElement('span');
          d.style.cssText = 'display:inline-flex;align-items:center;justify-content:center;width:26px;height:26px;border-radius:50%;font-size:10px;font-weight:700;background:' + (i < count ? '#16a34a' : '#e2e8f0') + ';color:' + (i < count ? '#fff' : '#94a3b8');
          d.textContent = w; pontos.appendChild(d);
        });
        if (count < 4 && can('notificar')) {
          const cob = document.createElement('button'); cob.type = 'button';
          const jaCob = p.cobrancas[al.alojId];
          cob.style.cssText = 'margin-left:auto;background:' + (count === 0 ? '#dc2626' : '#d97706') + ';color:#fff;border:none;border-radius:8px;padding:5px 12px;font-size:11px;font-weight:700;cursor:pointer;font-family:inherit';
          cob.textContent = '🔔 Cobrar' + (jaCob ? ' de novo' : '');
          if (jaCob) { const dc = new Date(jaCob); cob.title = 'Última cobrança: ' + dc.toLocaleDateString('pt-BR') + ' ' + dc.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }); }
          cob.onclick = function (ev) { ev.stopPropagation(); cobrarAloj(al.alojId, al.responsavel || al.nome, comp); };
          pontos.appendChild(cob);
        }
        box.appendChild(pontos);

        if (al.vistorias.length) {
          const lista = document.createElement('div');
          lista.style.cssText = 'margin-top:10px;border-top:1px dashed #e2e8f0;padding-top:8px;display:flex;flex-direction:column;gap:6px';
          al.vistorias.forEach(function (sr, i) {
            const s: VistoriaDTO | undefined = p.vistorias[sr.id];
            const st = sr.status;
            const rot = st === 'aprovada' ? 'Aprovada' : st === 'reprovada' ? 'Reprovada' : 'Pendente';
            const c2 = st === 'aprovada' ? ['#dcfce7', '#166534'] : st === 'reprovada' ? ['#fee2e2', '#b91c1c'] : ['#fef9c3', '#854d0e'];
            const li = document.createElement('div');
            li.style.cssText = 'display:flex;align-items:center;gap:8px;flex-wrap:wrap;font-size:12px;color:#475569';
            const dt = new Date(sr.enviadaEm);
            li.innerHTML = '<span style="font-weight:700;color:#1e293b">' + (sr.semana || (i + 1)) + 'ª</span>'
              + '<span>' + (isNaN(dt.getTime()) ? '' : dt.toLocaleDateString('pt-BR')) + '</span>'
              + '<span style="font-weight:700">' + (typeof sr.nota === 'number' ? sr.nota.toFixed(1) + '%' : '') + '</span>'
              + (s && s.tipo === 'anexo' ? '<span style="background:#e0e7ff;color:#3730a3;border-radius:99px;padding:2px 9px;font-size:10px;font-weight:800">📎 anexada</span>' : '')
              + '<span style="background:' + c2[0] + ';color:' + c2[1] + ';border-radius:99px;padding:2px 9px;font-size:10px;font-weight:800">' + rot + '</span>';
            const acoes = document.createElement('span');
            acoes.style.cssText = 'display:flex;gap:5px;margin-left:auto;flex-wrap:wrap';
            const pdf = document.createElement('button');
            pdf.style.cssText = 'background:#1F3864;color:#fff;border:none;border-radius:6px;padding:3px 9px;font-size:10px;font-weight:700;cursor:pointer;font-family:inherit';
            pdf.textContent = '📄 PDF';
            pdf.onclick = function (ev) { ev.stopPropagation(); seePDF(sr.id, s); };
            acoes.appendChild(pdf);
            if (st !== 'aprovada') {
              const ap = document.createElement('button');
              ap.style.cssText = 'background:#16a34a;color:#fff;border:none;border-radius:6px;padding:3px 9px;font-size:10px;font-weight:700;cursor:pointer;font-family:inherit';
              ap.textContent = '✓ Aprovar';
              ap.onclick = function (ev) { ev.stopPropagation(); doApprove(sr.id); };
              acoes.appendChild(ap);
            }
            if (st !== 'reprovada') {
              const rp = document.createElement('button');
              rp.style.cssText = 'background:#fff;color:#dc2626;border:1.5px solid #fca5a5;border-radius:6px;padding:3px 9px;font-size:10px;font-weight:700;cursor:pointer;font-family:inherit';
              rp.textContent = '✕ Reprovar';
              rp.onclick = function (ev) { ev.stopPropagation(); reprovarRapido(sr.id); };
              acoes.appendChild(rp);
            }
            li.appendChild(acoes);
            if (s && s.motivoReprovacao) {
              const mv = document.createElement('div');
              mv.style.cssText = 'width:100%;font-size:11px;color:#b91c1c;background:#fef2f2;border:1px solid #fca5a5;border-radius:8px;padding:5px 9px';
              mv.textContent = 'Motivo: ' + s.motivoReprovacao;
              li.appendChild(mv);
            }
            lista.appendChild(li);
          });
          box.appendChild(lista);
        }
        corpo.appendChild(box);
      });
      wrap.appendChild(corpo);
      obrasGrid.appendChild(wrap);
    });
  });
  el.appendChild(card);
}

export async function doApprove(id: string) {
  if (semAprovar()) return;
  try {
    await api('PATCH', '/api/vistorias/' + encodeURIComponent(id) + '/analise', { status: 'aprovada' });
    toast('✅ Aprovado!', 'success');
  } catch (e: any) { if (!(e instanceof ErroApi && e.status === 401)) toast('⚠️ ' + e.message, 'error'); }
  renderAdmin(S.tab);
}

export async function reprovarRapido(id: string) {
  if (semAprovar()) return;
  let motivo = prompt('Motivo da reprovação:', '');
  if (motivo === null) return;
  motivo = motivo.trim();
  if (!motivo) { alert('O motivo é obrigatório.'); return; }
  try {
    await api('PATCH', '/api/vistorias/' + encodeURIComponent(id) + '/analise', { status: 'reprovada', motivo });
    toast('✕ Vistoria reprovada', 'error');
  } catch (e: any) { if (!(e instanceof ErroApi && e.status === 401)) toast('⚠️ ' + e.message, 'error'); }
  renderAdmin(S.tab);
}

// ── Cobrar por e-mail (abre o programa de e-mail já preenchido) ──
export async function cobrarAloj(alId: string, nomeResp: string, comp: string) {
  if (!can('notificar')) { toast('🔒 Seu acesso não permite enviar notificações', 'error'); return; }
  let r: any;
  try {
    r = await api('POST', '/api/cobrancas', { alojId: alId, competencia: comp });
  } catch (e: any) {
    if (e instanceof ErroApi && e.status === 409) {
      const email = (prompt('Não há e-mail cadastrado para ' + nomeResp + '.\nDigite o e-mail do responsável (ele ficará salvo):') || '').trim();
      if (!email) return;
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { alert('E-mail inválido.'); return; }
      try { r = await api('POST', '/api/cobrancas', { alojId: alId, competencia: comp, email }); }
      catch (e2: any) { toast('⚠️ ' + e2.message, 'error'); return; }
      G.cadastro = []; // o e-mail novo entra no cadastro
    } else { if (!(e instanceof ErroApi && e.status === 401)) toast('⚠️ ' + e.message, 'error'); return; }
  }
  window.location.href = r.mailto;
}
